export default function getUpdatedByUserName(updatedBy) {
  let userName = '';
  if (updatedBy) {
    userName = (updatedBy.primary_role.type === 'system') ? 'Via Integration' : updatedBy.email_id;
  }
  return userName;
}
